var _themes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import guid from '../utils/guid';
import { getClassName } from '../utils/get-class-name';
import tscStyles from '../constants/TscStyles';
import InlineFieldGroup from '../InlineFieldGroup/InlineFieldGroup';
import TscThemeName from '../constants/TscThemeName';
import Radio from '../Radio/Radio';
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  mainTextColor: tscStyles.color.text.mediumDark,
  helpTextColor: tscStyles.color.text.medium
}), _defineProperty(_themes, TscThemeName.dusk, {
  mainTextColor: tscStyles.color.text.light,
  helpTextColor: tscStyles.color.text.lightMedium
}), _themes);
var Container = styled.div.withConfig({
  displayName: "InlineLabeledRadio__Container"
})(["margin-bottom:", ";width:100%;"], function (props) {
  return props.marginBottom;
});
var StyledText = styled.div.withConfig({
  displayName: "InlineLabeledRadio__StyledText"
})(["display:inline-block;&:before{content:'\\200b';line-height:1.4rem;}"]);
var StyledLabel = styled.label.withConfig({
  displayName: "InlineLabeledRadio__StyledLabel"
})(["color:", ";cursor:", ";margin-bottom:.5rem;line-height:1.25rem;"], function (props) {
  return themes[props.themeName].mainTextColor;
}, function (props) {
  return props.disabled ? 'text' : 'pointer';
});
var HiddenLabel = styled.label.withConfig({
  displayName: "InlineLabeledRadio__HiddenLabel"
})(["position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;"]);
var StyledHelperText = styled.div.withConfig({
  displayName: "InlineLabeledRadio__StyledHelperText"
})(["width:100%;color:", ";line-height:1.25rem;"], function (props) {
  return themes[props.themeName].helpTextColor;
});

var InlineLabeledRadio = function InlineLabeledRadio(_ref) {
  var className = _ref.className,
      description = _ref.description,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      groupId = _ref.groupId,
      _ref$isLabelHidden = _ref.isLabelHidden,
      isLabelHidden = _ref$isLabelHidden === void 0 ? false : _ref$isLabelHidden,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      label = _ref.label,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? '1rem' : _ref$marginBottom,
      onChange = _ref.onChange,
      testId = _ref.testId,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName;
  // generate this once
  var internalId = React.useMemo(function () {
    return "inline-labeled-radio-input-".concat(guid.new());
  }, []);
  return _jsx(Container, {
    className: getClassName(className, null, 'inline-labeled-radio-container'),
    marginBottom: marginBottom,
    children: _jsxs(InlineFieldGroup, {
      className: className,
      isVerticallyCentered: true,
      children: [_jsx(Radio, {
        className: className,
        sharedId: internalId,
        disabled: disabled,
        isSelected: isSelected,
        onChange: onChange,
        label: label,
        groupId: groupId,
        themeName: themeName,
        testId: testId
      }), _jsxs(StyledText, {
        className: getClassName(className, 'styled-text'),
        children: [!isLabelHidden ? _jsx(StyledLabel, {
          className: getClassName(className, 'styled-label'),
          htmlFor: internalId,
          disabled: disabled,
          themeName: themeName,
          children: label
        }) : _jsx(HiddenLabel, {
          className: getClassName(className, 'hidden-label'),
          htmlFor: internalId,
          children: label
        }), description && _jsx(StyledHelperText, {
          className: getClassName(className, 'styled-helper-text'),
          themeName: themeName,
          children: description
        })]
      })]
    })
  });
};

var InlineLabeledRadioTest = {
  Container: Container,
  StyledLabel: StyledLabel,
  HiddenLabel: HiddenLabel
};
export { InlineLabeledRadio, InlineLabeledRadioTest };
export default InlineLabeledRadio;